/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useRef, useState } from 'react';
import { Box } from 'native-base';

import { Stashboard, StashboardMedia, devLog, usePostStashboardInteractions, useSpringBigStore } from '@springbig/shared';

import _ReactPlayer, { ReactPlayerProps } from 'react-player';
import Image from '~/shared/Image';
import { useAppNavigate } from '~/pages';
import { useToast } from '~/hooks/toast';
import { useGeneralStyles } from '~/shared/styles';
import Button from '~/shared/Button';

const ReactPlayer = _ReactPlayer as unknown as React.FC<ReactPlayerProps>;

export const CarouselCard = ({ item, index, stashboard, setImgHeight }: {item: StashboardMedia, index: any, stashboard: Stashboard, setImgHeight: (height: number) => void}) => {

    const { navigate, params } = useAppNavigate();
    const { walletId } = useSpringBigStore();
    const { member  } = useSpringBigStore();
    const { mutate: postStashboardInteractions, error: errorPostStashboardInteractions } = usePostStashboardInteractions();
    const { errorToast } = useToast();
    const gStyle = useGeneralStyles();

    useEffect(() => {

        if (errorPostStashboardInteractions) {

            errorToast(errorPostStashboardInteractions.toString() + errorPostStashboardInteractions.data?.error?.toString());
            devLog(errorPostStashboardInteractions.toString() + errorPostStashboardInteractions.data?.error?.toString());
        }
    }, [errorPostStashboardInteractions]);

    const handlePressMessage = (stashboardMessage: Stashboard) => {

        navigate(`w/${walletId}/messages/${stashboardMessage._key}`, {
            state: {
                message: stashboardMessage
            },
        });
    };

    if (stashboard?.full_image_content) {

        if (params.stashboard_key) {
            const imgRef = useRef(null);
            const [imgWidth, setImgWidth] = useState(0);

            useEffect(() => {

                const handleResize = () => {

                    if (imgRef.current) {
                        setImgWidth(imgRef.current.clientWidth);
                        setImgHeight(imgRef.current.clientHeight);
                    }
                };

                if (imgRef.current) {
                    setImgWidth(imgRef.current.clientWidth);
                    setImgHeight(imgRef.current.clientHeight);
                }

                window.addEventListener('resize', handleResize);
                return () => {

                    window.removeEventListener('resize', handleResize);
                };
            }, [imgRef.current]);

            const handleImageLoad = () => {

                if (imgRef.current) {
                    setImgWidth(imgRef.current.clientWidth);
                }
            };

            return <div key={index} style={{ float: 'left', position: 'relative' }}>

                <img ref={imgRef} src={item.result_url} width={'100%'} onLoad={handleImageLoad} />
                {stashboard.full_image_content.map((full_image_content, index0) =>

                    full_image_content.buttons.map((button, index1) => {

                        const handleClick = () => {

                            window.open(button.target_url);
                            postStashboardInteractions({
                                interaction: {
                                    member_id: member?.id,
                                    merchant_id: member?.merchant_id,
                                    owner_type: 'StashboardImageButton',
                                    owner_id: button.id,
                                    action_type: 'stashboard_button_click',
                                }
                            });
                        };

                        return (
                            <button
                                key={`${index0}, ${index1}`}
                                style={{
                                    position: 'absolute',
                                    width: `${button.width}%`,
                                    height: `${imgWidth * button.height / 100}px`,
                                    top: `${imgWidth * button.y / 100}px`,
                                    left: `${button.x}%`,
                                    backgroundColor: button.style === 'visible' ? button.background_color : 'transparent',
                                    borderRadius: button.border_radius,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    border: 'none',
                                    padding: 0,
                                    margin: 0,
                                    boxShadow: 'none',
                                    color: button.text_color,
                                    fontSize: `${(button.font_size * imgWidth) / 100}px`,
                                    overflow: 'hidden',
                                }}
                                onClick={handleClick}
                            >
                                {button.text}
                            </button>
                        );
                    }
                    ))}
            </div>;
        }

        return (
            <div key={index} style={{ position: 'relative', width: 'clamp(320px, 100vw, 480px)', height: '480px' }}>
                <img src={item.result_url} width={'100%'} style={{ display: 'block' }} />
                <div style={{
                    background: 'linear-gradient(to right, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.5))',
                    position: 'absolute',
                    bottom: '0px',
                    left: '0',
                    width: '100%',
                    padding: '10px 0px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <Button
                        style={{
                            borderRadius: '25px',
                            padding: '10px 20px',
                            fontSize: '16px',
                            cursor: 'pointer',
                            textAlign: 'center',
                            width: '140px',
                            boxShadow: 'none',
                            border: '2px solid black',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            whiteSpace: 'nowrap',
                        }}
                        onPress={() => handlePressMessage(stashboard)}
                        backgroundColor={gStyle.button_background}
                        color={gStyle.button_text}
                    >
                        tap to see more
                    </Button>
                </div>
            </div>
        );

    }

    if (item?.media_type === 'video') {

        return (
            <Box key={index} w={'100%'} height={'96'} zIndex={99999}>
                <ReactPlayer url={item.result_url} width={'100%'} height={'100%'} />
            </Box>
        );
    }

    if (item?.media_type === 'image') {
        return (
            <Box key={index} w={'100%'} zIndex={99999}>
                <img src={item.result_url} width={'100%'} />
            </Box>
        );
    }

    return (
        <Box key={index} w={'100%'} height={96} zIndex={99999}>
            <Image
                w={'100%'}
                h={'96'}
                uri={`https://www.foot.com/wp-content/uploads/2017/06/placeholder-square.jpg`}
            />
        </Box>
    );
};
